import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EventType } from 'src/app/utils/interfaces/new/event-type.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-select-delete',
  templateUrl: './select-delete.component.html',
  styleUrls: [
    './select-delete.component.scss',
    '../../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class SelectDeleteComponent implements OnInit {

  public typeName;
  public replacementTypes: Array<EventType> = [];
  public replacementTypesLabel: Array<string> = [];
  public formGroup: FormGroup;

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter<string>();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
        this.closeModal();
    }
  }

  constructor(
    private formBuilder: FormBuilder
  ) { }

  async ngOnInit(): Promise<void> {
    await this.initTypesLabelList();
    await this.initSelectForm();
  }

  public cancel() {
    this.closeModal();
  }

  public saveType() {
    const typeId = this.replacementTypes.find(t => t.label === this.formGroup.get('selectedType').value).id;
    this.closeModal(typeId);
  }

  private async initTypesLabelList(): Promise<void> {
    return new Promise<void>(async(resolve) => {
      if (this.replacementTypes.length === 0) {
        setTimeout(async() => {
          await this.initTypesLabelList();
        }, 200);
      } else {
        for (const t of this.replacementTypes) {
          this.replacementTypesLabel.push(t.label);
        }
        resolve();
      }
    });
  }

  private async initSelectForm(): Promise<void> {
    return new Promise<void>(async(resolve) => {
      if (this.replacementTypesLabel.length === 0) {
        setTimeout(async() => {
          await this.initSelectForm();
        }, 200);
      } else {
        this.formGroup = this.formBuilder.group({
          selectedType: [this.replacementTypesLabel[0], Validators.required]
        });
        resolve();
      }
    });
  }

  public closeModal(typeId?: string): void {
    this.closeEmitter.emit(typeId);
  }

}
